module.exports = __webpack_public_path__ + "img/new years shrine visit i.57058da4.png";